

















import { Vue, Component } from 'vue-property-decorator'
import NewsList from '@/components/news/NewsList.vue'
import QuestionList from '@/components/question/QuestionList.vue'
import WidgetsWrapper from '@/components/dashboard_widgets/WidgetWrapper.vue'

@Component({
  components: { NewsList, QuestionList, WidgetsWrapper },
})
export default class Home extends Vue {
  get isLoading(): boolean {
    return this.$store.state.settings.loading
  }

  get isUseWidgetSettings() {
    return !!this.$store.state.settings?.widgets?.length
  }

  async created() {
    await this.$store.dispatch('settings/getWidgetSettings')
  }

  beforeDestroy() {
    this.$store.commit('settings/RESET_WIDGET')
  }
}
